import { render, staticRenderFns } from "./LoadingDots.vue?vue&type=template&id=8cd5c6d8&"
import script from "./LoadingDots.vue?vue&type=script&lang=js&"
export * from "./LoadingDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports